import _asyncToGenerator from "C:/GitLab-Runner/builds/VgMjNYji/0/billing/billingmalta/src/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { BreezeViewService } from '@common/services/breeze-view.service';
import { RememberStateService } from '@common/services/remember-state.service';
import * as _ from 'lodash';
import { firstValueFrom, isObservable, Subject, takeUntil } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/remember-state.service";
import * as i2 from "@common/services/breeze-view.service";
import * as i3 from "@angular/common";
import * as i4 from "@fortawesome/angular-fontawesome";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
const _c0 = function (a1) {
  return ["fas", a1];
};
const _c1 = function (a0) {
  return {
    hidden: a0
  };
};
function ActionBarComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function ActionBarComponent_div_0_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.toggleActionBarVisibility());
    });
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelement(2, "fa-icon", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵelement(4, "div", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(2, _c0, !ctx_r2.collapsed ? "chevron-circle-up" : "chevron-circle-down"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1, ctx_r2.collapsed));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_0_button_1_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 8);
  }
  if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(1, _c0, ctx_r15.icon(item_r11)));
  }
}
const _c2 = function (a0) {
  return {
    "background-color": a0
  };
};
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_0_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_0_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r19);
      const item_r11 = i0.ɵɵnextContext(2).$implicit;
      const actionGroup_r6 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r17 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r17.onClick(item_r11, actionGroup_r6));
    });
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_0_button_1_fa_icon_1_Template, 1, 3, "fa-icon", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext(2).$implicit;
    const actionGroup_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r14.isDisabled(item_r11, actionGroup_r6))("ngStyle", i0.ɵɵpureFunction1(4, _c2, item_r11.backgroundColor));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.icon(item_r11));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.label(item_r11), " ");
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_0_button_1_Template, 3, 6, "button", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r12 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isVisible(item_r11));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_1_ng_template_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_1_ng_template_1_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r29);
      const smallItem_r25 = i0.ɵɵnextContext().$implicit;
      const actionGroup_r6 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r27 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r27.onClick(smallItem_r25, actionGroup_r6));
    });
    i0.ɵɵelement(1, "fa-icon", 8);
    i0.ɵɵelementStart(2, "span", 26);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const smallItem_r25 = i0.ɵɵnextContext().$implicit;
    const actionGroup_r6 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r26.isDisabled(smallItem_r25, actionGroup_r6));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(3, _c0, ctx_r26.icon(smallItem_r25)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r26.label(smallItem_r25));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_1_ng_template_1_button_1_Template, 4, 5, "button", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const smallItem_r25 = ctx.$implicit;
    const ctx_r24 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.isVisible(smallItem_r25));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_1_ng_template_1_Template, 2, 1, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r11.smallItems);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_0_Template, 2, 1, "div", 16);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_div_1_Template, 2, 1, "div", 17);
  }
  if (rf & 2) {
    const item_r11 = ctx.$implicit;
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r9.label(item_r11));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.smallItems);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_button_1_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 8);
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r40 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(1, _c0, ctx_r40.icon(item_r34)));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_button_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r41 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r41.label(item_r34));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵlistener("click", function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r46);
      const item_r34 = i0.ɵɵnextContext(2).$implicit;
      const actionGroup_r6 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r44 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r44.onClick(item_r34, actionGroup_r6));
    });
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_button_1_fa_icon_1_Template, 1, 3, "fa-icon", 21);
    i0.ɵɵtemplate(2, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_button_1_div_2_Template, 2, 1, "div", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(2).$implicit;
    const actionGroup_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r39.isDisabled(item_r34, actionGroup_r6))("ngClass", i0.ɵɵpureFunction1(5, _c1, ctx_r39.collapsed))("ngStyle", i0.ɵɵpureFunction1(7, _c2, item_r34.backgroundColor));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r39.collapsed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r39.collapsed);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_button_1_Template, 3, 9, "button", 30);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext().$implicit;
    const ctx_r35 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.isVisible(item_r34));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_2_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 8);
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r54 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(1, _c0, ctx_r54.icon(item_r34)));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r58);
      const item_r34 = i0.ɵɵnextContext(2).$implicit;
      const actionGroup_r6 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r56 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r56.onClick(item_r34, actionGroup_r6));
    });
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_2_fa_icon_1_Template, 1, 3, "fa-icon", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(2).$implicit;
    const actionGroup_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r51 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r51.isDisabled(item_r34, actionGroup_r6))("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx_r51.collapsed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r51.collapsed);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r62 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r62.label(item_r34));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_5_div_1_Template, 2, 1, "div", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx_r52.collapsed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r52.collapsed);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_ng_template_7_button_0_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 8);
  }
  if (rf & 2) {
    const option_r64 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r66 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(1, _c0, ctx_r66.icon(option_r64)));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_ng_template_7_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 42);
    i0.ɵɵlistener("click", function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_ng_template_7_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r70);
      const option_r64 = i0.ɵɵnextContext().$implicit;
      const actionGroup_r6 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r68 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r68.onClick(option_r64, actionGroup_r6));
    });
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_ng_template_7_button_0_fa_icon_1_Template, 1, 3, "fa-icon", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r64 = i0.ɵɵnextContext().$implicit;
    const actionGroup_r6 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r65 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r65.isDisabled(option_r64, actionGroup_r6));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r65.icon(option_r64));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r65.label(option_r64), " ");
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_ng_template_7_button_0_Template, 3, 3, "button", 41);
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r53 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r53.isVisible(item_r34));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "div");
    i0.ɵɵtemplate(2, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_2_Template, 2, 5, "button", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div")(4, "div", 35);
    i0.ɵɵtemplate(5, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_button_5_Template, 2, 4, "button", 36);
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵtemplate(7, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_ng_template_7_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext().$implicit;
    const ctx_r36 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r36.isVisible(item_r34));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r36.collapsed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r34.options);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_button_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "fa-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r78 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(1, _c0, ctx_r78.icon(item_r34)));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_button_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r79 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r79.label(item_r34));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_button_2_div_1_Template, 2, 3, "div", 43);
    i0.ɵɵtemplate(2, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_button_2_div_2_Template, 2, 1, "div", 39);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx_r76.collapsed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r76.collapsed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r76.collapsed);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_ng_template_4_button_0_fa_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 8);
  }
  if (rf & 2) {
    const option_r82 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r84 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(1, _c0, ctx_r84.icon(option_r82)));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_ng_template_4_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r88 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 42);
    i0.ɵɵlistener("click", function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_ng_template_4_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r88);
      const option_r82 = i0.ɵɵnextContext().$implicit;
      const actionGroup_r6 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r86 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r86.onClick(option_r82, actionGroup_r6));
    });
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_ng_template_4_button_0_fa_icon_1_Template, 1, 3, "fa-icon", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r82 = i0.ɵɵnextContext().$implicit;
    const actionGroup_r6 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r83 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r83.isDisabled(option_r82, actionGroup_r6));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.icon(option_r82));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r83.label(option_r82), " ");
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_ng_template_4_button_0_Template, 3, 3, "button", 41);
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r77 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r77.isVisible(item_r34));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 35);
    i0.ɵɵtemplate(2, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_button_2_Template, 3, 5, "button", 36);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵtemplate(4, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_ng_template_4_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext().$implicit;
    const ctx_r37 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r37.collapsed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", item_r34.options);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_button_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "fa-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const smallItem_r95 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r97 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction1(1, _c0, ctx_r97.icon(smallItem_r95)));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_button_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const smallItem_r95 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r98 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r98.label(smallItem_r95));
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 46);
    i0.ɵɵlistener("click", function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r103);
      const smallItem_r95 = i0.ɵɵnextContext().$implicit;
      const actionGroup_r6 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r101 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r101.onClick(smallItem_r95, actionGroup_r6));
    });
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_button_1_span_1_Template, 2, 3, "span", 47);
    i0.ɵɵtemplate(2, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_button_1_span_2_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const smallItem_r95 = i0.ɵɵnextContext().$implicit;
    const actionGroup_r6 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r96 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r96.isDisabled(smallItem_r95, actionGroup_r6))("ngClass", i0.ɵɵpureFunction1(4, _c1, ctx_r96.collapsed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r96.collapsed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r96.collapsed);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_button_1_Template, 3, 6, "button", 45);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const smallItem_r95 = ctx.$implicit;
    const ctx_r94 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r94.isVisible(smallItem_r95) && !ctx_r94.collapsed);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_ng_template_1_Template, 2, 1, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r34 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r34.smallItems);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_0_Template, 2, 1, "div", 27);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_1_Template, 8, 3, "div", 28);
    i0.ɵɵtemplate(2, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_2_Template, 5, 2, "div", 29);
    i0.ɵɵtemplate(3, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_div_3_Template, 2, 1, "div", 17);
  }
  if (rf & 2) {
    const item_r34 = ctx.$implicit;
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r10.label(item_r34) && !item_r34.options);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r34.options && item_r34.isSplit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r34.options && !item_r34.isSplit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r34.smallItems);
  }
}
function ActionBarComponent_div_0_ng_template_2_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r109 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 13);
    i0.ɵɵlistener("mouseover", function ActionBarComponent_div_0_ng_template_2_div_0_Template_div_mouseover_0_listener() {
      i0.ɵɵrestoreView(_r109);
      const _r8 = i0.ɵɵreference(1);
      const ctx_r108 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r108.openActionGroupDropdown(_r8));
    });
    i0.ɵɵelementStart(2, "div", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵtemplate(5, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_5_Template, 2, 2, "ng-template", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ActionBarComponent_div_0_ng_template_2_div_0_ng_template_6_Template, 4, 4, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const actionGroup_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(actionGroup_r6.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", actionGroup_r6.items);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", actionGroup_r6.items);
  }
}
function ActionBarComponent_div_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ActionBarComponent_div_0_ng_template_2_div_0_Template, 7, 3, "div", 11);
  }
  if (rf & 2) {
    const actionGroup_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r3.isVisible(actionGroup_r6));
  }
}
const _c3 = function (a0) {
  return {
    "fixed minimized": a0
  };
};
function ActionBarComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, ActionBarComponent_div_0_div_1_Template, 5, 6, "div", 3);
    i0.ɵɵtemplate(2, ActionBarComponent_div_0_ng_template_2_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelement(3, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, ctx_r0.collapsed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.collapsible);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
  }
}
const _c4 = function (a0) {
  return {
    "margin-bottom": a0
  };
};
function ActionBarComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 48);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c4, (ctx_r1.collapsed ? 20 : 120) + "px"));
  }
}
export class ActionBarConfig {}
/*
 * A component that makes it easy to create actionbar (toolbar)
 */
export class ActionBarComponent {
  constructor(rememberStateService, breezeViewService) {
    this.rememberStateService = rememberStateService;
    this.breezeViewService = breezeViewService;
    this.collapsed = false;
    this.collapsible = true;
    this.tooltipPlacement = 'bottom';
    this.tooltipOpenDelay = 1000;
    this.actionBarStatus = {
      collapsed: this.collapsed,
      empty: false
    };
    this.destroy$ = new Subject();
    breezeViewService.userService.currentUserSubject.pipe(takeUntil(this.destroy$)).subscribe(user => {
      this.user = user;
    });
  }
  ngOnInit() {
    if (!this.hasAnyVisibleGroup()) this.actionBarStatus.empty = true;
    this.collapsed = this.rememberStateService.initialize('actionBar');
  }
  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
  openActionGroupDropdown(dropdown) {
    if (this.collapsed) dropdown.open();
  }
  onClick(item, group) {
    var _this = this;
    return _asyncToGenerator(function* () {
      if (item.onClick && !_this.isDisabled(item, group)) {
        let result = item.onClick();
        if (result) {
          try {
            item._isBusy = true;
            if (isObservable(result)) {
              result = firstValueFrom(result);
            }
            yield result;
          } catch (e) {}
          item._isBusy = false;
        }
      }
    })();
  }
  label(item) {
    if (_.isFunction(item.label)) {
      return item.label();
    }
    return item.label;
  }
  icon(item) {
    if (_.isFunction(item.icon)) {
      return item.icon();
    }
    return item.icon;
  }
  isDisabled(item, group) {
    if (_.isBoolean(group.isDisabled) && group.isDisabled || _.isFunction(group.isDisabled) && group.isDisabled() || _.isBoolean(item.isDisabled) && item.isDisabled || _.isFunction(item.isDisabled) && item.isDisabled()) {
      return true;
    }
    return item._isBusy === true;
  }
  isVisible(item) {
    if (_.isFunction(item.isVisible) && !item.isVisible()) {
      return false;
    }
    if (_.isBoolean(item.isVisible) && !item.isVisible) {
      return false;
    }
    if (item.items) {
      return _.some(item.items, x => this.isVisible(x));
    }
    if (item.permissions) {
      return this.user?.hasPermission(...item.permissions);
    }
    return true;
  }
  toggleActionBarVisibility() {
    this.collapsed = this.actionBarStatus.collapsed = !this.collapsed;
    this.rememberStateService.setState('actionBar', this.collapsed);
  }
  hasAnyVisibleGroup() {
    return this.items && _.some(this.items, x => this.isVisible(x));
  }
}
ActionBarComponent.ɵfac = function ActionBarComponent_Factory(t) {
  return new (t || ActionBarComponent)(i0.ɵɵdirectiveInject(i1.RememberStateService), i0.ɵɵdirectiveInject(i2.BreezeViewService));
};
ActionBarComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: ActionBarComponent,
  selectors: [["app-action-bar"]],
  inputs: {
    items: "items",
    collapsed: "collapsed",
    collapsible: "collapsible",
    tooltipPlacement: "tooltipPlacement",
    tooltipOpenDelay: "tooltipOpenDelay"
  },
  features: [i0.ɵɵProvidersFeature([BreezeViewService])],
  decls: 2,
  vars: 2,
  consts: [["class", "action-bar", 3, "ngClass", 4, "ngIf"], [3, "ngStyle", 4, "ngIf"], [1, "action-bar", 3, "ngClass"], ["class", "action-bar-group toggle", 3, "click", 4, "ngIf"], ["ngFor", "", 3, "ngForOf"], [2, "clear", "both"], [1, "action-bar-group", "toggle", 3, "click"], [1, "group-label", 2, "height", "19px"], [3, "icon"], [1, "action-bar-item"], [1, "btn", "arrow", 3, "ngClass"], ["class", "action-bar-group", "ngbDropdown", "", 3, "mouseover", 4, "ngIf"], ["ngbDropdown", "", 1, "action-bar-group", 3, "mouseover"], ["dropdown", "ngbDropdown"], ["ngbDropdownAnchor", "", 1, "group-label"], ["ngbDropdownMenu", ""], ["class", "action-bar-item medium", 4, "ngIf"], ["class", "small-buttons-container", 4, "ngIf"], [1, "action-bar-item", "medium"], ["class", "btn", 3, "disabled", "ngStyle", "click", 4, "ngIf"], [1, "btn", 3, "disabled", "ngStyle", "click"], [3, "icon", 4, "ngIf"], [1, "small-buttons-container"], [1, "action-bar-item", "small"], ["class", "btn", 3, "disabled", "click", 4, "ngIf"], [1, "btn", 3, "disabled", "click"], [1, "btn-label"], ["class", "action-bar-item", 4, "ngIf"], ["class", "action-bar-item split-btn", 4, "ngIf"], ["class", "action-bar-item small", 4, "ngIf"], ["class", "btn", 3, "disabled", "ngClass", "ngStyle", "click", 4, "ngIf"], [1, "btn", 3, "disabled", "ngClass", "ngStyle", "click"], ["class", "btn-label", 4, "ngIf"], [1, "action-bar-item", "split-btn"], ["class", "btn icon-btn", 3, "disabled", "ngClass", "click", 4, "ngIf"], ["ngbDropdown", ""], ["class", "btn", "type", "button", "style", "line-height: 20px", "ngbDropdownToggle", "", 3, "ngClass", 4, "ngIf"], [1, "btn", "icon-btn", 3, "disabled", "ngClass", "click"], ["type", "button", "ngbDropdownToggle", "", 1, "btn", 2, "line-height", "20px", 3, "ngClass"], ["class", "btn-label caret", 4, "ngIf"], [1, "btn-label", "caret"], ["ngbDropdownItem", "", 3, "disabled", "click", 4, "ngIf"], ["ngbDropdownItem", "", 3, "disabled", "click"], ["style", "padding-top: 15px; margin-bottom: 8px", 4, "ngIf"], [2, "padding-top", "15px", "margin-bottom", "8px"], ["class", "btn", 3, "disabled", "ngClass", "click", 4, "ngIf"], [1, "btn", 3, "disabled", "ngClass", "click"], [4, "ngIf"], [3, "ngStyle"]],
  template: function ActionBarComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵtemplate(0, ActionBarComponent_div_0_Template, 4, 5, "div", 0);
      i0.ɵɵtemplate(1, ActionBarComponent_div_1_Template, 1, 3, "div", 1);
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", ctx.hasAnyVisibleGroup());
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.hasAnyVisibleGroup());
    }
  },
  dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgStyle, i4.FaIconComponent, i5.NgbDropdown, i5.NgbDropdownAnchor, i5.NgbDropdownToggle, i5.NgbDropdownMenu, i5.NgbDropdownItem],
  styles: [".action-bar[_ngcontent-%COMP%] {\n  z-index: 99;\n  position: fixed;\n  margin-left: -24px;\n  margin-top: -2px;\n  width: 100%;\n  min-height: 19px;\n  background-color: #fff;\n  border-bottom: 19px solid #f1f1f1;\n  box-shadow: rgba(0, 0, 0, 0.25) 3px 2px 5px 0;\n}\n.action-bar[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%] {\n  width: 20px !important;\n  margin-bottom: 19px;\n}\n.action-bar.fixed[_ngcontent-%COMP%] {\n  width: 100%;\n  position: fixed;\n  margin-top: -6px;\n  border-bottom: 19px solid #fff;\n}\n.action-bar[_ngcontent-%COMP%]   .hidden[_ngcontent-%COMP%] {\n  height: auto !important;\n}\n.action-bar[_ngcontent-%COMP%]   .group-label[_ngcontent-%COMP%] {\n  background-color: #f1f1f1;\n  overflow: hidden;\n  height: 19px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  color: #333;\n  text-align: center;\n  font-size: 13px;\n}\n.action-bar[_ngcontent-%COMP%]   .toggle[_ngcontent-%COMP%] {\n  cursor: pointer;\n}\n.action-bar.minimized[_ngcontent-%COMP%]   .group-label[_ngcontent-%COMP%] {\n  background-color: #fff;\n}\n.action-bar.minimized[_ngcontent-%COMP%]   .group-label[_ngcontent-%COMP%]:hover {\n  background-color: #f1f1f1;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]:hover    > .dropdown-menu[_ngcontent-%COMP%] {\n  visibility: visible;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%] {\n  float: left;\n  margin-bottom: -19px;\n  max-height: 125px;\n  position: relative;\n  border-right: 1px solid #dee2e6;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%] {\n  visibility: hidden;\n  margin-left: -1px !important;\n  margin-top: -2px !important;\n  padding: 0;\n  box-shadow: rgba(0, 0, 0, 0.25) 3px 2px 5px 0;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]::after {\n  display: none;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .small-buttons-container[_ngcontent-%COMP%] {\n  float: left;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%] {\n  float: left;\n  height: -moz-fit-content;\n  height: fit-content;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%] {\n  white-space: inherit;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%] {\n  font-size: 13px;\n  margin-right: 10px;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%] {\n  font-size: 35px;\n  color: #333;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]:hover   button[_ngcontent-%COMP%]:not(:disabled).btn, .action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]:hover   button[_ngcontent-%COMP%]:not(:disabled)   .btn-label[_ngcontent-%COMP%], .action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]:hover   button[_ngcontent-%COMP%]:not(:disabled)   fa-icon[_ngcontent-%COMP%] {\n  color: #007bff;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.small[_ngcontent-%COMP%] {\n  float: none;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.small[_ngcontent-%COMP%]   *[_ngcontent-%COMP%] {\n  text-align: left;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.small[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%] {\n  margin-left: 5px;\n  font-size: 13px;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.small[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n  height: 35px;\n  margin-bottom: 0;\n  width: 100%;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.medium[_ngcontent-%COMP%] {\n  float: none;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.medium[_ngcontent-%COMP%]   *[_ngcontent-%COMP%] {\n  text-align: left;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.medium[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%] {\n  margin-left: 5px;\n  font-size: 20px;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.medium[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n  height: 50px;\n  margin-bottom: 0;\n  width: 100%;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .btn-label[_ngcontent-%COMP%] {\n  height: 40px;\n  padding: 0 5px;\n  font-size: 13px;\n  line-height: 1.2;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n  height: 106px;\n  width: 80px;\n  padding: 0;\n  overflow: hidden;\n  margin-bottom: 19px;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:active:not(:disabled) {\n  box-shadow: inset 0 0 8px 0 #4b646f !important;\n  background-color: #fff;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:focus {\n  box-shadow: none;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.split-btn[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%] {\n  height: 46px;\n  margin-bottom: 0;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.split-btn[_ngcontent-%COMP%]   .icon-btn[_ngcontent-%COMP%] {\n  height: 58px;\n  padding-top: 6px;\n  margin-bottom: 0;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.disabled[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%], .action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.disabled[_ngcontent-%COMP%]   .btn-label[_ngcontent-%COMP%], .action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%], .action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]   .btn-label[_ngcontent-%COMP%] {\n  color: #b8c7ce;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item.disabled[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:active, .action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .disabled[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:active {\n  box-shadow: none !important;\n}\n.action-bar[_ngcontent-%COMP%]   .action-bar-group[_ngcontent-%COMP%]   .action-bar-item[_ngcontent-%COMP%]   .caret[_ngcontent-%COMP%]::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n  box-sizing: border-box;\n  content: \"\";\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
});